import { IApiEmployee, IOrderFiltersInput } from 'next-common';
import { IFilterBarProps } from '../FilterBar';
import { categoryOptions } from '../FilterBar/CategoryFilter';
import { SellerFilter } from '../FilterBar/SellerFilter';
import { OrderCategory } from '../orderQuery.utils';
import { Button } from '@repo/ui/components';

interface IOverviewHeader extends Partial<IFilterBarProps> {
  filter: IOrderFiltersInput;
  category: OrderCategory;
  employee: IApiEmployee;
  isAdmin: boolean;
  onClick(): void;
}

export const OverviewHeader = (props: IOverviewHeader) => {
  const { isAdmin, onClick } = props;

  const handleSellerChange = (e) => {
    if (props?.onChange) props?.onChange('salesPersonIdent', e.value);
  };

  return (
    <div className="flex justify-between items-end ">
      <div className="flex flex-col">
        <span className="m-0 text-lg/[175%] font-semibold text-black">Min oversikt</span>
        <h1 className="m-0 !text-[2rem]/[139%] font-extrabold text-black">
          {categoryOptions?.find((facet) => facet?.value === props?.category)?.label ?? ''}
        </h1>
      </div>
      <div id="sellerContainer" className="flex justify-end items-end gap-4">
        {isAdmin && (
          <Button
            onClick={onClick}
            className="px-[1.875rem] font-bold !enabled:hover:bg-turquoise focus:ring-0 enabled:hover:bg-teal w-full"
            variant="teal"
          >
            Start nytt salg
          </Button>
        )}
        <SellerFilter
          employee={props.employee}
          dealerIds={props.filter.dealerIds}
          selected={props.filter.salesPersonIdent}
          onChange={handleSellerChange}
        />
      </div>
    </div>
  );
};
